import React from 'react';
import PropTypes from 'prop-types';
import { Block } from '@webfox-sc/core';
import './asset-item.scss';
import IconPdf60 from '../../assets/icons/IconPdf60';
import IconImage60 from '../../assets/icons/IconImage60';
import IconPlay60 from '../../assets/icons/IconPlay60';
import { useOverlayContext } from '../overlay/OverlayProvider';

const iconMap = {
  agenda: IconPdf60,
  presentation: IconPdf60,
  picture: IconImage60,
  video: IconPlay60,
};

const AssetItem = ({ asset }) => {
  const { overlayNavigate } = useOverlayContext();

  const handleClick = () => {
    if (asset.type === 'video' && asset.eventId && asset.videoIndex != null) {
      overlayNavigate(`/downloads/media-library/${asset.eventId}/${asset.videoIndex}`);
    }
  };

  const renderThumbnail = () => {
    const icon = iconMap[asset.type];
    const isImageOrVideo = asset.type === 'picture' || asset.type === 'video';
    const imageSrc = asset.type === 'picture' || asset.type === 'video' ? asset.thumbnail || asset.url : null;

    return (
      <Block className="bt-asset-item__thumbnail">
        {isImageOrVideo && <img src={imageSrc} alt={asset.title} className="bt-asset-item__image" />}
        <span className="bt-asset-item__icon">{icon}</span>
      </Block>
    );
  };

  const renderInfo = () => (
    <>
      <p className="bt-asset-item__title">{asset.title}</p>
      <p className="bt-asset-item__info">
        {asset.eventTitle} &nbsp;&nbsp;|&nbsp;&nbsp; {asset.dateTime}
      </p>
    </>
  );

  const isDownloadable = asset.type === 'agenda' || asset.type === 'presentation' || asset.type === 'picture';

  if (isDownloadable) {
    return (
      <a className="bt-asset-item__download" href={asset.url} target="_blank" download>
        <Block className={`bt-asset-item bt-asset-item--${asset.type}`}>
          {renderThumbnail()}
          {renderInfo()}
        </Block>
      </a>
    );
  }

  if (asset.type === 'video') {
    return (
      <Block className="bt-asset-item bt-asset-item--video" onClick={handleClick}>
        {renderThumbnail()}
        {renderInfo()}
      </Block>
    );
  }

  return null;
};

AssetItem.propTypes = {
  asset: PropTypes.shape({
    type: PropTypes.string.isRequired,
    title: PropTypes.string,
    url: PropTypes.string,
    thumbnail: PropTypes.string,
    eventId: PropTypes.number,
    videoIndex: PropTypes.number,
    eventTitle: PropTypes.string,
    dateTime: PropTypes.string,
  }).isRequired,
};

export default AssetItem;
